import { render, staticRenderFns } from "./sousTraitantmodal.vue?vue&type=template&id=229bb085&scoped=true"
import script from "./sousTraitantmodal.vue?vue&type=script&lang=js"
export * from "./sousTraitantmodal.vue?vue&type=script&lang=js"
import style0 from "./sousTraitantmodal.vue?vue&type=style&index=0&id=229bb085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bb085",
  null
  
)

export default component.exports